<template>
  <div class="meeting-agenda">
    <div class="page-header-banner">
      <div class="banner-main-content">
        <h1>技术分论坛</h1>
        <p>SUB-FORUM</p>
        <p>2021/12/01 - 2021/12/03</p>
      </div>
    </div>
    <div class="agenda-list">
      <div class="common-forum-agenda">
        <div class="timetable-time-fourm">
          <div class="time-list">
            <span
              v-for="(item, index) of subDateList"
              :key="index"
              :class="{ 'activity-time': currentDate === item }"
              @click="changeDate(item)"
              >{{ item }}</span
            >
            <p>（分论坛逐日解锁，请选择日期观看）</p>
          </div>
          <div class="forum-list">
            <span
              :class="{ 'tab-active': classifyId == item.id }"
              v-for="item in showTableList"
              :key="item.id"
              @click="getClassifyClick(item.id)"
              >{{ item.subFourm }}</span
            >
          </div>
        </div>
        <div class="main-timetable">
          <!-- 播放器 -->
          <div style="margin: 10px 0;">
            <VideoComponent
              :timeList="selfSubList"
              :mainTitle="videoPlayerMainTitle + '议程'"
              :subTitle="videoPlayerSubTitle"
              :areaId="areaId"
            />
          </div>

          <div class="timetable-list">
            <div class="publisher-info">
              <img :src="subList.img" />
              <div>
                <div class="pub-name">
                  {{ subList.pubName }}
                  <span class="pub-position">{{ subList.pubPositon }}</span>
                </div>
                <div class="pub-content">{{ subList.pubContent }}</div>
              </div>
            </div>
            <div class="publisher-info" v-if="subList.pubName2">
              <img :src="subList.img2" />
              <div>
                <div class="pub-name">
                  {{ subList.pubName2 }}
                  <span class="pub-position">{{ subList.pubPositon2 }}</span>
                </div>
                <div class="pub-content">{{ subList.pubContent2 }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="sub-forum-guests froum-guests">
        <div class="main-title">
          <div class="forum-icon"></div>
          <div>
            <span>论坛嘉宾</span>
            <span class="forum-guests">FORUM GUESTS</span>
          </div>
        </div>
        <div class="sub-guests">
          <div
            v-for="(item, indexG) in guestsList"
            :key="indexG"
            class="li_list"
          >
            <div class="sub-has-bg"></div>
            <div class="sub-guests-info">
              <span></span>
              <div class="sub-guests-name">{{ item.name }}</div>
              <div class="sub-guests-position">{{ item.company }}</div>
              <div class="sub-guests-position">{{ item.position }}</div>
            </div>
            <img :src="item.img" alt />
            <div class="sub-forum-title">{{ item.title }}</div>
          </div>
        </div>
      </div>
      <div class="common-forum-agenda">
        <div class="main-title">
          <div class="first-icon"></div>
          <div>
            <span style="letter-spacing:20px;">合作伙伴</span>
            <span style="letter-spacing:4px;">PARTNERSHIP</span>
          </div>
        </div>
        <div class="main-timetable coop-partner">
          <div v-for="item of coopPartnerList" :key="item.img">
            <img :src="item.img" alt />
          </div>
        </div>
      </div>
    </div>
    <div class="common-forum-agenda meeting-bg">
      <div class="main-title">
        <div class="second-icon"></div>
        <div>
          <span>会务信息</span>
          <span>MEETING MESSAGE</span>
        </div>
      </div>
      <div class="main-timetable conference-info" style="padding-bottom:64px">
        <div class="hs-logo"></div>
        <div class="hs-qr-code"></div>
        <div class="contant-int">
          <div>
            会务咨询：
            <span>戚女士 0571-26693359</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import VideoComponent from "./components/videoCom";
import { get_signup_end_time } from "@/api/developerConference.js";

export default {
  data() {
    return {
      classifyId: 0,
      subTimeList: [], //分论坛
      subList: [], //在展示的分论坛
      coopPartnerList: [], //合作伙伴图片
      selfSubList: [], //当前分论坛议程数组
      videoPlayerMainTitle: "",
      videoPlayerSubTitle: "",
      subDateList: [],
      showTableList: [],
      subFourmGuests: [], // 所有分论坛嘉宾
      currentDate: "",
      areaId: 0
    };
  },

  components: {
    VideoComponent
  },

  computed: {
    // 当前论坛嘉宾
    guestsList() {
      return this.subFourmGuests.filter(
        guest => guest.area_name === this.videoPlayerMainTitle
      );
    }
  },
  created() {
    // 为了消除横向滚动条注释掉了
    $("body").css({
      overflow: "auto"
    });
    // this.subList = this.subTimeList[0]
  },
  mounted() {
    this.getSubTimeList();
    this.getSubGuestList();
    this.getPartnerShipList();
  },
  watch: {
    subList(newVal, oldVal) {
      this.selfSubList = newVal.list.map(val => {
        return {
          time: val.time,
          active: val.active,
          speaker: val.speaker,
          position: val.position,
          video: val.playback,
          img: val.img
        };
      });
    }
  },
  methods: {
    /**
     * 描述
     * 为了实现进入页面可以根据当前时间进入分论坛，增加一个时间获取函数，在加载数据跳到当前时间直播的分论坛
     * @date 2021-11-08
     * @returns {undefined}
     */
    getLocalTime() {
      get_signup_end_time().then(res => {
        const timeStamp = new Date(res.current_time);
        const currentDay = timeStamp.getDate();
        if (timeStamp.getFullYear() === 2021 && timeStamp.getMonth() === 11) {
          if (currentDay === 2) {
            this.changeDate("12月02日");
          } else if (currentDay === 3) {
            this.changeDate("12月03日");
          } else {
            this.changeDate("12月01日");
          }
        } else {
          this.changeDate("12月01日");
        }
      });
    },

    /*传递数据给播放器组件*/
    getClassifyClick(num) {
      // 高亮
      this.classifyId = num;
      // 传递分论坛议程到播放器组件
      this.subTimeList.forEach(ele => {
        if (num == ele.id) {
          this.subList = [];
          this.subList = ele;
        }
      });
      // 传递标题和副标题area_name以及分论坛id
      this.videoPlayerMainTitle = this.subList.area_name;
      this.videoPlayerSubTitle = this.subList.date + this.subList.time;
      this.areaId = num;
      // 将议程的滚动条置顶
      const eles = document.getElementsByClassName("innerbox");
      eles[0].scrollTop = 0;
    },

    //从cms上获取分论坛时间
    getSubTimeList() {
      axios({
        url:
          "/r/cms/www/itn/json/deveConference/testFroumList.json?time=" +
          +new Date(),
        method: "get",
        headers: {
          "content-type": "application/x-www-form-urlencoded;charset=UTF-8"
        },
        withCredentials: true
      }).then(res => {
        // 为了不多次请求数据，将分论坛数据使用subtimelist变量保存
        // 使用单独的sublist变量用来展示当前论坛
        this.subTimeList = res.data;
        this.subList = this.subTimeList[0];
        // 传递videoplayer组件标题
        this.videoPlayerMainTitle = this.subList.area_name;
        // 获取时间数组，采用了去重
        res.data.map(val => {
          if (!this.subDateList.includes(val.date)) {
            this.subDateList.push(val.date);
          }
        });
        // 为了不让页面空白，赋予初值
        // this.changeDate(this.subDateList[0]);
        this.getLocalTime();
      });
    },

    // 从cms上获取合作伙伴地址
    getPartnerShipList() {
      axios({
        url:
          "/r/cms/www/itn/json/deveConference/partnershipList.json?time=" +
          +new Date(),
        method: "get",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        },
        withCredentials: true
      }).then(res => {
        this.coopPartnerList = res.data;
      });
    },

    // 查看另一日期的分论坛议程
    changeDate(date) {
      this.currentDate = date;
      const res = [];
      for (let item of this.subTimeList) {
        if (date === item.date) {
          res.push({ subFourm: item.area_name, id: item.id });
        }
      }
      // 与时间对应的分论坛列表
      this.showTableList = [...res];
      // 将第一个论坛的数据传递给播放器组件
      this.getClassifyClick(res[0].id);
    },

    // 从cms上获取分论坛嘉宾信息
    getSubGuestList() {
      axios({
        url:
          "/r/cms/www/itn/json/deveConference/forumGuests.json?time=" +
          +new Date(),
        method: "get",
        headers: {
          "content-type": "application/x-www-form-urlencoded;charset=UTF-8"
        },
        withCredentials: true
      }).then(res => {
        this.subFourmGuests = res.data;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.meeting-agenda {
  .page-header-banner {
    width: 100%;
    min-width: 1200px;
    height: 465px;
    background: url("../../../assets/developerConference/main_sub_banner-big.jpg")
      no-repeat center;
    background-size: cover;
    color: #ffffff;
    .banner-main-content {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      h1 {
        font-family: MicrosoftYaHei-Bold;
        font-size: 44px;
        padding-top: 159px;
        color: #333333;
        line-height: 54px;
        font-weight: 700;
      }
      p {
        font-family: MicrosoftYaHei-Bold;
        font-size: 28px;
        color: #ffffff;
        color: #000000;
        text-align: left;
        &:last-of-type {
          font-family: MicrosoftYaHei;
          font-size: 22px;
          opacity: 0.8;
          padding-top: 5px;
        }
      }
    }
  }
  @media screen and (max-width: 1366px) {
    .page-header-banner {
      height: 399px;
      background: url("../../../assets/developerConference/main_sub_banner-small.jpg")
        no-repeat center center;
    }
  }

  .meeting-bg {
    position: relative;
    background: url("../../../assets/developerConference/meeting-bg.jpg")
      no-repeat;
    background-size: cover;
    background-position: center;
  }
  .common-forum-agenda {
    .main-title {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 30px;
      font-family: MicrosoftYaHei;
      padding-bottom: 43px;

      > div:nth-child(1) {
        background-size: cover;
        width: 100px;
        height: 100px;
      }

      > div:nth-child(2) {
        display: flex;
        flex-direction: column;
        span:nth-child(1) {
          font-size: 28px;
          letter-spacing: 25px;
          color: #000;
        }
        span:nth-child(2) {
          font-size: 20px;
          color: #666;
        }
      }

      > div:nth-child(3) {
        color: #333333;
        font-family: ArialMT;
      }
      .forum-icon {
        background: url("../../../assets/developerConference/forum-guests-icon.png");
        margin-right: 16px;
      }
      .first-icon {
        background: url("../../../assets/developerConference/partners-icon.png");
        margin-right: 16px;
      }
      .second-icon {
        background: url("../../../assets/developerConference/meeting-icon.png");
        margin-right: 16px;
      }
    }
    .conference-info {
      padding: 0 102px 59px 80px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .hs-logo {
        width: 196px;
        height: 73px;
        background: url("../../../assets/developerConference/coor_hs_logo.png")
          no-repeat center;
        background-size: 100% 100%;
      }
      .hs-qr-code {
        width: 116px;
        height: 116px;
        background: url("../../../assets/developerConference/code_img.jpg")
          no-repeat center;
        background-size: 100% 100%;
        position: relative;
        &:before {
          display: inline-block;
          content: "";
          width: 16px;
          height: 16px;
          background: url("../../../assets/developerConference/code_img_top.png")
            no-repeat center;
          background-size: 100% 100%;
          position: absolute;
          top: -2px;
          left: -2px;
        }
        &:after {
          display: inline-block;
          content: "";
          width: 16px;
          height: 16px;
          background: url("../../../assets/developerConference/code_img_bottom.png")
            no-repeat center;
          background-size: 100% 100%;
          position: absolute;
          bottom: -2px;
          right: -2px;
        }
      }
      .contant-int {
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #666666;
        text-align: left;
        line-height: 36px;
        span {
          color: #333333;
        }
        > div {
          &:nth-child(1) {
            &:before {
              display: inline-block;
              content: "";
              width: 23px;
              height: 24px;
              background: url("../../../assets/developerConference/ticket_service.png")
                no-repeat center;
              background-size: 100% 100%;
              vertical-align: middle;
              margin-right: 15px;
            }
          }
          &:nth-child(2) {
            &:before {
              display: inline-block;
              content: "";
              width: 23px;
              height: 24px;
              background: url("../../../assets/developerConference/business_coor.png")
                no-repeat center;
              background-size: 100% 100%;
              vertical-align: middle;
              margin-right: 15px;
            }
          }
          &:nth-child(3) {
            &:before {
              display: inline-block;
              content: "";
              width: 24px;
              height: 23px;
              background: url("../../../assets/developerConference/media_coor.png")
                no-repeat center;
              background-size: 100% 100%;
              vertical-align: middle;
              margin-right: 15px;
            }
          }
        }
      }
    }
  }
  .agenda-list {
    margin: 0 auto;
    padding-top: 64px;
    width: 1200px;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #333333;
    overflow: hidden;
    .common-forum-agenda {
      .main-timetable {
        .publisher-info {
          width: 1200px;
          height: 300px;
          background-image: linear-gradient(135deg, #f9fbff 0%, #f2f7fe 100%);
          border-radius: 3px 3px 0 0;
          border: 1px solid #d3dce8;
          margin-bottom: 25px;
          position: relative;
          &:before {
            display: inline-block;
            content: "出品人";
            background-image: linear-gradient(
              270deg,
              rgba(66, 169, 255, 0) 0%,
              #1f70fd 85%
            );
            height: 36px;
            width: 117px;
            font-family: MicrosoftYaHei-Bold;
            font-size: 16px;
            color: #ffffff;
            padding: 6px 0 0 15px;
            position: absolute;
            left: 0;
            top: 0px;
          }
          &:after {
            display: inline-block;
            content: "";
            background-image: linear-gradient(
              194deg,
              #eff6ff 25%,
              #76a6fa 100%
            );
            height: 4px;
            width: 100%;
            position: absolute;
            left: 0;
            bottom: 0px;
          }
          img {
            width: 250px;
            height: 263.8px;
            position: absolute;
            left: 68px;
            bottom: 4px;
          }
          > div {
            padding-top: 89.7px;
            margin-left: 388px;
            width: 702px;
            .pub-name {
              font-family: MicrosoftYaHei-Bold;
              font-size: 24px;
              color: #333333;
              margin-bottom: 24.6px;
              position: relative;
              .pub-position {
                font-family: MicrosoftYaHei;
                font-size: 14px;
                color: #666666;
                padding-left: 16px;
              }
              &:before {
                width: 24px;
                height: 5px;
                background: #1f70fd;
                display: inline-block;
                content: "";
                position: absolute;
                top: -12px;
                left: 0px;
              }
            }
            .pub-content {
              font-family: PingFangSC-Regular;
              font-size: 14px;
              color: #333333;
              text-align: justify;
              line-height: 24px;
              word-wrap: break-word;
            }
          }
        }
      }
      .coop-partner {
        margin-bottom: 46px;
        display: flex;
        flex-wrap: wrap;
        div {
          width: 224px;
          margin-right: 20px;
          align-items: flex-start;
          // background-color: #fff;
          margin-bottom: 20px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        div:nth-child(5n) {
          margin-right: 0;
        }
      }
    }
  }
  .froum-guests {
    .main-title {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 30px;
      font-family: MicrosoftYaHei;
      padding-bottom: 43px;

      > div:nth-child(1) {
        background-size: cover;
        width: 100px;
        height: 100px;
      }
      > div:nth-child(2) {
        display: flex;
        flex-direction: column;
        span:nth-child(1) {
          font-size: 28px;
          letter-spacing: 25px;
          color: #000;
        }
        span:nth-child(2) {
          font-size: 20px;
          color: #666;
        }
        .forum-guests {
          letter-spacing: 3px;
        }
      }

      > div:nth-child(3) {
        color: #333333;
        font-family: ArialMT;
      }
      .forum-icon {
        background: url("../../../assets/developerConference/forum-guests-icon.png");
        margin-right: 23px;
      }
    }
  }
  .sub-forum-guests {
    .sub-guests {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      & > div {
        width: 380px;
        height: 200px;
        background: #ffffff;
        border: 1px solid #d2dbe8;
        border-radius: 3px;
        position: relative;
        margin-right: 30px;
        margin-bottom: 30px;

        &:nth-child(n) {
          .sub-guests-info {
            > span {
              display: block;
              width: 19px;
              height: 4px;
              background: url("../../../assets/developerConference/line-top.png")
                no-repeat center;
              background-size: 100% 100%;
              margin-bottom: 7px;
            }
          }
        }

        &:nth-child(3n-1) {
          .sub-guests-info {
            > span {
              display: block;
              width: 19px;
              height: 4px;
              background: url("../../../assets/developerConference/line-top.png")
                no-repeat center;
              background-size: 100% 100%;
              margin-bottom: 7px;
            }
          }
        }

        &:nth-child(3n) {
          margin-right: 0;
        }

        &:after {
          display: block;
          content: "";
          width: 378px;
          height: 4px;
          transform: scaleX(-1), rotate(180deg);
          background: url("../../../assets/developerConference/line-bottom.png")
            no-repeat center;
          background-size: 100% 100%;
          position: absolute;
          bottom: 50px;
          left: 0px;
        }

        .sub-has-bg {
          width: 380px;
          height: 149px;
          opacity: 0.29;
          background: #fff;
          border-radius: 3px 3px 0 0;
        }

        .sub-guests-info {
          position: absolute;
          top: 33px;
          left: 27px;
          width: 215px;

          .sub-guests-name {
            font-family: MicrosoftYaHei-Bold;
            font-size: 20px;
            color: #333333;
            font-weight: 700;
          }

          .sub-guests-position {
            font-family: MicrosoftYaHei;
            font-size: 14px;
            color: #666666;
          }
        }

        img {
          width: 140px;
          // height: 197px;
          position: absolute;
          bottom: 52px;
          right: 13px;
        }

        .sub-forum-title {
          font-family: PingFangSC-Medium;
          font-size: 14px;
          color: #333333;
          overflow: hidden;
          white-space: nowrap;
          width: 100%;
          display: inline-block;
          text-overflow: ellipsis;
          padding-left: 23px;
          padding-top: 13px;
          font-weight: 500;
        }
      }
    }
  }
}
.timetable-time-fourm {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;

  .time-list {
    display: flex;
    justify-content: space-between;
    & span {
      display: inline-block;
      font-size: 16px;
      height: 24px;
      cursor: pointer;
    }
    span:nth-child(2) {
      margin: 0 20px;
    }
    .activity-time {
      color: #0d3dfa;
      position: relative;
      &::after {
        display: inline-block;
        content: "";
        height: 2px;
        transform: scaleX(1);
        transform-origin: bottom left;
        width: 100%;
        background-image: linear-gradient(270deg, #4945ff 0%, #3ffffe 100%);
        position: absolute;
        bottom: -10px;
        left: 0;
      }
    }
    & p {
      margin-left: 12px;
      height: 24px;
      font-size: 16px;
    }
  }
  .forum-list {
    display: flex;
    font-size: 16px;
    & span {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 137px;
      margin: 0 16px;
      height: 40px;
      background: #e2e5f4;
      border-radius: 2px;
      cursor: pointer;
    }
    .tab-active {
      background: url("../../../assets/developerConference/tab_bg.png")
        no-repeat center;
      background-size: 100% 100%;
      font-family: PingFangSC-Semibold;
      color: #fff;
      font-weight: 600;
    }
  }
}
</style>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/gtn/views/frontViews/developerConference/subForum.vue